import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

import Form from '../components/form';
import { testConditions, testValidators } from '../forms';

const FormContainer = createReactClass({

  propTypes: {
    title: PropTypes.string,
    variant: PropTypes.string,
    model: PropTypes.shape({}),
    onUpdate: PropTypes.func,
    onLoad: PropTypes.func,
    schema: PropTypes.shape({}),
    form: PropTypes.shape({}),
    isDisabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      title: '',
      variant: 'default',
      model: {},
      onUpdate: () => { },
      onLoad: () => { },
      schema: {},
      form: {},
      isDisabled: false,
    };
  },

  getInitialState() {
    return {
      formState: {},
      hasInitialised: false,
    };
  },

  componentDidMount() {
    const formState = {};
    const { schema, model } = this.props;
    each(schema, (schemaValue, schemaKey) => {
      formState[schemaKey] = {
        isDirty: false,
        ...this.validateField({ key: schemaKey, model, schema: schemaValue }),
      };
    });

    this.setState({ formState, hasInitialised: true });

    this.props.onLoad({
      formState,
      hasError: this.hasFormError,
      errorField: this.errorField,
      error: this.formError,
    });
  },

  onUpdateField({ update }) {
    const { model, schema, onUpdate } = this.props;

    this.hasFormError = false;
    this.formError = null;
    this.errorField = null;

    const preemptedModel = cloneDeep(model);

    this.setState((prevState) => {
      const { formState } = prevState;

      each(update, (updateValue, updateKey) => {
        preemptedModel[updateKey] = updateValue;
        formState[updateKey] = { ...formState[updateKey], isDirty: true };
      });

      // test all fields' conditions and validators
      each(schema, (schemaValue, schemaKey) => {
        const fieldState = this.validateField({
          key: schemaKey,
          model: preemptedModel,
          schema: schemaValue,
        });

        const { hasCondition, setValue } = fieldState;
        const shouldSetValue = hasCondition && setValue !== undefined;

        if (shouldSetValue && !isEqual(preemptedModel[schemaKey], setValue)) {
          Object.assign(update, { [schemaKey]: setValue });
        }

        Object.assign(formState[schemaKey], fieldState);
      });

      return { formState };
    }, () => {
      onUpdate({
        update,
        formState: this.state.formState,
        hasError: this.hasFormError,
        errorField: this.errorField,
        error: this.formError,
      });
    });
  },

  validateField({ key, model, schema }) {
    const conditionProps = testConditions(key, schema, model);
    const errorProps = testValidators(key, schema, model, conditionProps);

    if (errorProps.hasError && !this.hasFormError) {
      Object.assign(this, { errorField: key, formError: errorProps.error, hasFormError: true });
    }

    return { ...conditionProps, ...errorProps };
  },

  hasFormError: false,

  render() {
    if (!this.state.hasInitialised) return null;

    const {
      title, model, schema, form, variant, isDisabled,
    } = this.props;

    return (
      <Form
        title={title}
        variant={variant}
        model={model}
        schema={schema}
        form={form || {}}
        state={this.state.formState}
        onUpdateField={this.onUpdateField}
        isDisabled={isDisabled}
      />
    );
  },
});

export default React.memo(FormContainer);
